import { useState } from "react";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AICommentary({ assetType, symbol, range = 180 }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const res = await api.aiAnalysis(assetType, symbol, range);
      setData(res.ai);
    } catch (e) {
      toast.error("AI analysis failed");
    } finally {
      setLoading(false);
    }
  };

  if (!data && !loading) {
    return (
      <div className="space-y-4">
        <p className="text-sm text-zinc-400 leading-relaxed">
          Run Claude Sonnet 5 on the latest indicators and price action to get a
          personalized bullish/bearish read.
        </p>
        <button
          data-testid="run-ai-btn"
          onClick={run}
          className="inline-flex items-center gap-2 bg-[#FFD600] text-black hover:bg-white h-10 px-4 text-xs uppercase font-bold tracking-widest transition-colors"
        >
          <Sparkle size={14} weight="fill" />
          Generate AI read
        </button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="text-xs text-zinc-500 animate-pulse">
        Claude is reading the tape…
      </div>
    );
  }

  const trendColor =
    data.trend === "bullish"
      ? "text-[#00FF66]"
      : data.trend === "bearish"
      ? "text-[#FF3B30]"
      : "text-zinc-400";

  return (
    <div data-testid="ai-commentary" className="border border-[#FFD600]/40 bg-[#FFD600]/5 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <span
          className={`text-xs uppercase tracking-widest font-bold ${trendColor}`}
        >
          {data.trend} · {data.confidence}%
        </span>
        <button
          onClick={run}
          data-testid="rerun-ai-btn"
          className="text-[10px] uppercase tracking-widest text-zinc-500 hover:text-white transition-colors"
        >
          Regenerate
        </button>
      </div>

      <p className="text-sm text-white leading-relaxed">{data.summary}</p>

      {Array.isArray(data.key_points) && data.key_points.length > 0 && (
        <ul className="space-y-1.5">
          {data.key_points.map((p, i) => (
            <li key={i} className="text-xs text-zinc-300 flex items-start gap-2">
              <ArrowRight size={12} weight="bold" className="text-[#FFD600] mt-0.5" />
              <span>{p}</span>
            </li>
          ))}
        </ul>
      )}

      {data.risk && data.risk !== "N/A" && (
        <div className="pt-3 border-t border-zinc-800">
          <div className="overline text-[9px]">Risk / what would flip this</div>
          <p className="text-xs text-zinc-400 mt-1">{data.risk}</p>
        </div>
      )}
    </div>
  );
}
